import axios from "./axios/config";

export const getReportFields = async (type) => {
  const res = await axios.get(`report/type?type=${type}`);
  return res.data;
};

export const generate = async (page, size, data) => {
  const res = await axios.post(`report?page=${page}&size=${size}`, data);
  return res.data;
};

export const getSearchFields = async () => {
  const res = await axios.get("search/base");
  return res.data;
};

export const exportSingle = async (data) => {
  const res = await axios.post("/api/report/single/export", data);
  return res.data();
};

export const getReportLabels = async () => {
  const res = await axios.get("/report/labels");
  return res;
};

export const getReports = async (page, size, data) => {
  const res = await axios.post(`report?page=${page}&size=${size}`, data);
  return res.data;
};

export const exportSingleReport = async (data) => {
  const res = await axios({
    url: "report/single/export/checked",
    responseType: "blob",
    data,
    method:"POST"
  });

  return res;
};

export const exportMultiReport = async (data) => {
  const res = await axios({
    url: "/report",
    responseType: "blob",
    data,
    method: "POST",
  });

  return res;
};

export const exportReports = async (data) => {
  const res = await axios.post("/report", {
    responseType: "blob",
    data,
  });

  return res.data;
};
